import { useEffect } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";

export const AmbientOrb = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 40, damping: 20 });
  const sy = useSpring(my, { stiffness: 40, damping: 20 });
  const rotateX = useTransform(sy, [-200, 200], [8, -8]);
  const rotateY = useTransform(sx, [-200, 200], [-8, 8]);

  useEffect(() => {
    const handle = (e) => {
      mx.set(e.clientX - window.innerWidth / 2);
      my.set(e.clientY - window.innerHeight / 2);
    };
    window.addEventListener("mousemove", handle);
    return () => window.removeEventListener("mousemove", handle);
  }, [mx, my]);

  return (
    <motion.div
      style={{ rotateX, rotateY }}
      className="absolute inset-0 flex items-center justify-center pointer-events-none"
      data-testid="ambient-orb"
    >
      <motion.div
        animate={{ scale: [1, 1.08, 1], opacity: [0.55, 0.8, 0.55] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="w-[420px] h-[420px] rounded-full blur-3xl"
        style={{ background: "radial-gradient(circle, rgba(196,123,94,0.35) 0%, rgba(74,107,86,0.25) 45%, transparent 75%)" }}
      />
      <motion.div
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        className="absolute w-[260px] h-[260px] rounded-full blur-2xl"
        style={{ background: "radial-gradient(circle, rgba(226,234,228,0.9) 0%, transparent 70%)" }}
      />
    </motion.div>
  );
};
